// 中文语言包
export default {
  // 通用
  common: {
    appName: '第五人格统一赛事平台',
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    search: '搜索',
    submit: '提交',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    yes: '是',
    no: '否',
    all: '全部',
    more: '更多',
    close: '关闭',
    refresh: '刷新',
    copy: '复制',
    share: '分享',
    download: '下载',
    upload: '上传',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '提示',
    noData: '暂无数据',
    required: '必填',
    optional: '选填',
    passwordStrength: '强度',
    improvementSuggestions: '改进建议',
    passwordStrengthWeak: '弱',
    passwordStrengthFair: '中',
    passwordStrengthGood: '良',
    passwordStrengthStrong: '强',
  },

  // 导航栏
  nav: {
    home: '首页',
    events: '赛事看板',
    teams: '战队',
    articles: '帖子',
    community: '社区',
    participants: '参赛者',
    organizer: '赛事主办方',
    messages: '信息',
    notifications: '通知',
    profile: '个人资料',
    login: '登录',
    register: '注册',
    logout: '退出登录',
    search: '全站搜索',
    docs: '使用文档',
    terms: '用户协议',
    privacy: '隐私政策',
    theme: '主题',
    themeLight: '亮色',
    themeDark: '暗色',
    themeTapeFuturism: '磁带未来主义',
    language: '语言',
    christmas: '圣诞节',
    christmasGreeting: '圣诞快乐',
    christmasMessage: 'Merry Christmas！平安喜乐，万事顺遂',
    snowEffect: '下雪特效',
    christmasWish: '🎅 祝大家节日快乐！🎁',
  },

  // 菜单项
  menu: {
    eventBoard: '赛事看板',
    createTeam: '创建战队',
    editTeam: '编辑我的战队',
    dataAnalysis: '数据分析',
    personalProfile: '个人资料',
    globalSearch: '全站搜索',
    userDocs: '使用文档',
    articleList: '帖子列表',
    publishArticle: '发布帖子',
    createEvent: '创建赛事',
    myEvents: '我的赛事',
  },

  // 首页
  home: {
    hero: {
      title: '第五人格赛事统一管理平台',
      subtitle: '面向所有主办方的赛事创建、报名审核、赛程管理一体化平台。',
      subtitle2: '降低运营成本，提升参赛体验，让每一场比赛更精彩。',
      createEvent: '创建赛事',
      joinEvent: '参与赛事',
      browseEvents: '浏览赛事',
      free: '免费使用',
      oneClickRegistration: '一键报名',
      efficientManagement: '高效管理',
    },
    features: {
      title: '为主办方而生的关键能力',
      subtitle: '覆盖赛事全流程，降低运营成本，提升参赛体验',
      createEvent: {
        title: '创建与配置赛事',
        description: '支持报名时间、比赛时间、队伍上限、赛事说明等核心配置,快速发布赛事。',
      },
      registration: {
        title: '报名与审核',
        description: '队伍在线报名,管理员审核与状态管理，确保参赛资格规范透明。',
      },
      schedule: {
        title: '赛程与沟通',
        description: '管理赛程安排、队伍信息与通知发布,提升组织效率与参赛体验。',
      },
    },
    partners: {
      title: '合作伙伴',
      subtitle: '与我们共同构建更开放与高效的赛事生态',
      expand: '展开更多',
      collapse: '收起',
    },
    cta: {
      title: '立即开始',
      subtitle: '加入我们，让赛事组织更轻松',
      createNow: '立即创建赛事',
      viewDocs: '查看文档',
    },
  },

  // 赛事相关
  event: {
    title: '赛事',
    list: '赛事列表',
    detail: '赛事详情',
    create: '创建赛事',
    edit: '编辑赛事',
    manage: '管理赛事',
    name: '赛事名称',
    description: '赛事说明',
    status: '赛事状态',
    startTime: '开始时间',
    endTime: '结束时间',
    regStartTime: '报名开始时间',
    regEndTime: '报名截止时间',
    maxTeams: '队伍上限',
    currentTeams: '当前队伍数',
    organizer: '主办方',
    format: '赛制',
    prize: '奖励',
    rules: '规则',
    contact: '联系方式',
    register: '报名参赛',
    registered: '已报名',
    registrationClosed: '报名已截止',
    registrationNotStarted: '报名未开始',
    bracket: '对阵表',
    schedule: '赛程',
    results: '比赛结果',
    participants: '参赛队伍',
    statusLabels: {
      draft: '草稿',
      published: '已发布',
      registration: '报名中',
      ongoing: '进行中',
      completed: '已结束',
      cancelled: '已取消',
    },
  },

  // 战队相关
  team: {
    title: '战队',
    list: '战队列表',
    detail: '战队详情',
    create: '创建战队',
    edit: '编辑战队',
    name: '战队名称',
    tag: '战队简称',
    description: '战队介绍',
    logo: '战队Logo',
    captain: '队长',
    members: '队员',
    memberCount: '队员数量',
    joinTeam: '加入战队',
    leaveTeam: '离开战队',
    invitePlayer: '邀请队员',
    kickPlayer: '移除队员',
    transferCaptain: '转让队长',
    disbandTeam: '解散战队',
    apply: '申请加入',
    pending: '审核中',
    approved: '已通过',
    rejected: '已拒绝',
    myTeam: '我的战队',
    noTeam: '暂无战队',
  },

  // 用户相关
  user: {
    profile: '个人资料',
    avatar: '头像',
    nickname: '昵称',
    email: '邮箱',
    phone: '手机号',
    password: '密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    changePassword: '修改密码',
    bio: '个人简介',
    gameId: '游戏ID',
    rank: '段位',
    role: '角色偏好',
    stats: '数据统计',
    achievements: '成就',
    history: '历史记录',
    settings: '设置',
  },

  // 认证相关
  auth: {
    login: '登录',
    register: '注册',
    logout: '退出登录',
    email: '邮箱',
    password: '密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    noAccount: '还没有账号？',
    hasAccount: '已有账号？',
    goLogin: '去登录',
    goRegister: '去注册',
    loginSuccess: '登录成功',
    logoutSuccess: '已退出登录',
    registerSuccess: '注册成功',
    welcomeBack: '欢迎回来',
    verifyEmail: '验证邮箱',
    sendCode: '发送验证码',
    verifyCode: '验证码',
    thirdPartyLogin: '使用第三方登录',
    emailPlaceholder: '请输入邮箱',
    passwordPlaceholder: '请输入密码',
    passwordHint: '至少 8 位，包含字母与数字；建议加入特殊字符',
    confirmPasswordPlaceholder: '请再次输入密码',
    fullName: '姓名',
    fullNamePlaceholder: '请输入您的真实姓名',
    loginFailed: '登录失败',
    registerFailed: '注册失败',
    emailFormatError: '邮箱格式不正确',
    passwordMinLength: '密码至少 8 位',
    passwordMustContainLetterAndNumber: '需包含字母与数字',
    agreeToTerms: '我已阅读并同意',
    termsOfService: '用户协议',
    and: '和',
    privacyPolicy: '隐私政策',
    mustAgreeToTerms: '请同意用户协议和隐私政策',
    loginTitle: '登录',
    registerTitle: '注册',
    passwordSuggestLength: '增加长度到 12+ 位',
    passwordSuggestUppercase: '加入大写字母',
    passwordSuggestLowercase: '加入小写字母',
    passwordSuggestDigit: '加入数字',
    passwordSuggestSymbol: '加入特殊字符（!@#…）',
  },

  // 文章/帖子相关
  article: {
    title: '帖子',
    list: '帖子列表',
    detail: '帖子详情',
    create: '发布帖子',
    edit: '编辑帖子',
    articleTitle: '标题',
    content: '内容',
    category: '分类',
    tags: '标签',
    author: '作者',
    publishTime: '发布时间',
    views: '浏览量',
    likes: '点赞',
    comments: '评论',
    share: '分享',
    collect: '收藏',
    report: '举报',
    delete: '删除',
  },

  // 消息相关
  message: {
    title: '消息',
    inbox: '收件箱',
    sent: '已发送',
    unread: '未读',
    read: '已读',
    markAsRead: '标记已读',
    markAllRead: '全部已读',
    delete: '删除',
    noMessages: '暂无消息',
    newMessage: '新消息',
    sendMessage: '发送消息',
    reply: '回复',
    conversation: '对话',
  },

  // 通知相关
  notification: {
    title: '通知',
    all: '全部通知',
    unread: '未读通知',
    system: '系统通知',
    event: '赛事通知',
    team: '战队通知',
    markAsRead: '标记已读',
    markAllRead: '全部已读',
    clear: '清空通知',
    noNotifications: '暂无通知',
  },

  // 时间相关
  time: {
    justNow: '刚刚',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    daysAgo: '{n} 天前',
    weeksAgo: '{n} 周前',
    monthsAgo: '{n} 月前',
    yearsAgo: '{n} 年前',
  },

  // 表单验证
  validation: {
    required: '此字段为必填项',
    email: '请输入有效的邮箱地址',
    emailRequired: '请输入邮箱',
    passwordRequired: '请输入密码',
    minLength: '最少需要 {n} 个字符',
    maxLength: '最多允许 {n} 个字符',
    passwordMatch: '两次输入的密码不一致',
    invalidFormat: '格式不正确',
  },

  // 错误信息
  errors: {
    networkError: '网络错误，请稍后重试',
    serverError: '服务器错误，请稍后重试',
    unauthorized: '请先登录',
    forbidden: '没有权限执行此操作',
    notFound: '请求的资源不存在',
    unknown: '发生未知错误',
    timeout: '请求超时，请稍后重试',
  },

  // 页脚
  footer: {
    copyright: '© {year} 第五人格统一赛事平台',
    allRightsReserved: '保留所有权利',
    contact: '联系我们',
    about: '关于我们',
    feedback: '意见反馈',
  },

  // 404页面
  notFound: {
    title: '页面未找到（404）',
    subtitle: '可能链接有误、内容已迁移，或权限不足。',
    goHome: '返回首页',
    goEvents: '去赛事看板',
    goArticles: '去文章列表',
    trySearch: '试试站内搜索',
    searchPlaceholder: '例如：ASG、秋季赛、战队名称',
    searchButton: '搜索',
    goBack: '返回上一页',
    possibleReasons: '可能的原因',
    reason1: '链接输入错误或已失效',
    reason2: '内容已被删除或移动',
    reason3: '需要登录后才能访问',
    reason4: '您没有足够的权限',
  },

  // 赛事看板页面
  eventBoard: {
    title: '赛事看板',
    subtitle: '浏览正在报名与即将开始的赛事',
    activeRegistration: '正在报名',
    upcomingEvents: '即将开始',
    activeRegistrationTab: '正在报名',
    upcomingTab: '即将开始',
    noActiveEvents: '暂无正在报名的赛事',
    noUpcomingEvents: '暂无即将开始的赛事',
    registerNow: '立即报名',
    viewDetails: '查看详情',
    loadingEvents: '加载赛事中...',
    registrationPeriod: '报名时间',
    eventPeriod: '比赛时间',
    teamsCount: '{current}/{max} 队伍',
    registerSuccess: '报名成功',
    registerFailed: '报名失败',
  },

  // 战队创建页面
  teamCreate: {
    title: '创建战队',
    subtitle: '填写战队信息并邀请队员',
    teamInfo: '战队信息',
    teamName: '战队名称',
    teamPassword: '战队密码',
    teamPasswordHint: '用于队员加入战队时验证身份',
    qqNumber: 'QQ号',
    qqNumberRequired: '请填写QQ号',
    teamDescription: '战队介绍',
    teamLogo: '战队Logo',
    uploadLogo: '上传Logo',
    generateAiLogo: '使用AI生成',
    playerList: '队员列表',
    addPlayer: '添加队员',
    removePlayer: '移除',
    hidePlayers: '隐藏队员信息',
    hidePlayersHint: '隐藏后其他用户无法查看队员详情',
    createSuccess: '创建战队成功，正在跳转到编辑页面',
    createFailed: '创建战队失败',
    descriptionTooLong: '战队描述字数需小于 1000',
    logoRequired: '请上传队伍Logo或使用AI生成',
    generating: '生成中...',
    polishing: '润色中...',
  },

  // 玩家信息表单
  player: {
    name: '玩家名称',
    gameId: '游戏ID',
    gameRank: '段位',
    description: '个人介绍',
    playerType: '角色类型',
    survivor: '求生者',
    hunter: '监管者',
    both: '双修',
  },

  // 通用页面组件
  page: {
    loadMore: '加载更多',
    noMoreData: '没有更多了',
    loading: '加载中...',
    retry: '重试',
    page: '第 {n} 页',
    totalPages: '共 {n} 页',
    prevPage: '上一页',
    nextPage: '下一页',
    goToPage: '前往',
  },

  // 隐私政策页面
  privacy: {
    title: '隐私政策',
    intro: '本平台重视您的隐私与数据安全。本隐私政策旨在说明我们如何收集、使用、存储与保护您的个人信息，以及您在个人信息处理中的权利。',
    section1: '收集的信息',
    section1Content: '我们可能收集的个人信息包括：邮箱、昵称或姓名、战队信息、赛事参与记录、您在平台发布的文章与互动数据，以及为保障安全所需的日志信息。',
    section2: '信息的使用',
    section2Content: '我们使用这些信息以提供与改进平台服务，包括账号认证与安全、赛事管理与通知、社区互动、内容推荐与统计分析等。',
    section3: 'Cookies 与本地存储',
    section3Content: '平台可能使用 Cookies 或本地存储保存登录状态与偏好设置。您可以通过浏览器设置进行管理或清除。',
    section4: '信息共享与披露',
    section4Content: '我们不会向未授权的第三方出售或披露您的个人信息，除非出于法律法规要求、执法部门请求或为保护平台及用户合法权益所必需。',
    section5: '数据安全',
    section5Content: '我们采用合理的技术与管理措施（如加密与访问控制）保护您的数据安全，但无法保证绝对安全。请妥善保管您的账户与密码。',
    section6: '数据保留',
    section6Content: '我们会在实现目的所需的最短期间内保留个人信息，并依据法律法规与业务需要对数据进行归档或删除。',
    section7: '您的权利',
    section7Content: '您有权访问、更正与删除个人信息，并可在法律允许范围内撤回授权或申请注销账户。部分请求可能影响服务使用。',
    section8: '未成年人保护',
    section8Content: '如您为未成年人，应在监护人指导下使用本平台。未经监护人同意，我们不会主动收集未成年人个人信息。',
    section9: '政策更新',
    section9Content: '隐私政策可能因业务或法律变化而更新。更新后的政策在平台发布后生效，继续使用即视为您已同意。',
    section10: '联系我们',
    section10Content: '如您对隐私政策或个人信息处理有疑问与投诉，可通过平台反馈渠道与我们联系。',
  },

  // 用户协议页面
  terms: {
    title: '用户协议',
    intro: '欢迎使用第五人格统一赛事平台（以下简称"本平台"）。为保障您的合法权益，请在使用前仔细阅读并同意本用户协议。本平台为赛事主办方、参赛者与社区用户提供赛事创建与管理、战队信息维护、赛程与比分录入、文章发布与互动等服务。',
    section1: '账户注册与使用',
    section1Content: '您应当使用真实、合法的邮箱注册账户，并妥善保管登录凭证。通过本平台创建的内容和操作行为由您本人承担相应责任。',
    section2: '平台使用规范',
    section2Content: '您不得利用本平台从事任何违法、违规或侵害他人合法权益的行为，包括但不限于：发布不当内容、恶意攻击、破坏平台或他人数据、未经授权的数据抓取与复制。',
    section3: '内容与知识产权',
    section3Content: '您在本平台发布的文字、图片、视频等内容应确保拥有合法使用权或已取得必要授权。未经许可，不得擅自转载或用于商业用途。本平台对自身提供的功能、界面与代码等享有相应的知识产权。',
    section4: '数据与安全',
    section4Content: '本平台采用合理的技术与管理措施保障数据安全与服务稳定，但仍可能因网络与不可抗力因素导致服务中断或数据丢失。因用户自身原因造成的账号泄露与损失由用户承担。',
    section5: '赛事与赛程',
    section5Content: '赛事主办方应保证赛事信息的真实性与合规性，妥善管理赛程、比分与参与战队信息。参赛者应遵循赛事规则并尊重裁判与其他参与方。',
    section6: '通知与邮件',
    section6Content: '本平台可能向您发送与账号安全、密码重置、赛事提醒等相关的服务邮件。您可在法律允许范围内选择接收与退订。',
    section7: '责任与免责',
    section7Content: '由于第三方服务、网络环境或不可抗力导致的服务异常，本平台不承担由此产生的间接损失。因用户违反本协议或法律法规造成的损失，由用户承担相应责任。',
    section8: '协议更新',
    section8Content: '本平台可根据业务与法律法规变更对协议进行更新。更新后的协议一经公布即生效，若您继续使用本平台，即视为已接受更新内容。',
    section9: '适用法律与争议解决',
    section9Content: '本协议受相关法律法规管辖。因本协议产生的争议，双方应友好协商解决；协商不成的，提交有管辖权的人民法院处理。',
    section10: '联系方式',
    section10Content: '如对本协议或平台使用有任何疑问，可通过平台提供的反馈渠道与我们联系。',
  },

  // 综合搜索页面
  search: {
    title: '综合搜索',
    subtitle: '按关键词搜索战队、赛事与文章',
    placeholder: '搜索站内内容（战队 / 赛事 / 文章）',
    searchType: '搜索类型',
    all: '全部',
    teams: '战队',
    events: '赛事',
    articles: '文章',
    searchButton: '搜索',
    teamsCount: '战队：{count}',
    eventsCount: '赛事：{count}',
    articlesCount: '文章：{count}',
    teamResults: '战队结果',
    eventResults: '赛事结果',
    articleResults: '文章结果',
    noTeamsFound: '没有找到匹配的战队',
    noEventsFound: '没有找到匹配的赛事',
    noArticlesFound: '没有找到匹配的文章',
    tryDifferentKeyword: '试试换个关键词或检查拼写',
    membersHidden: '队员已隐藏',
    noDescription: '暂无战队描述',
    expand: '展开',
    collapse: '收起',
    viewDetail: '查看详情',
    like: '点赞',
  },

  // 忘记密码页面
  forgotPassword: {
    title: '忘记密码',
    emailLabel: '邮箱',
    sendResetEmail: '发送重置邮件',
    backToLogin: '返回登录',
    successMsg: '如果该邮箱存在，我们已发送重置邮件',
    emailRequired: '请输入邮箱',
    emailFormatError: '邮箱格式不正确',
    operationFailed: '操作失败',
  },

  // 重置密码页面
  resetPassword: {
    title: '重置密码',
    emailLabel: '邮箱',
    tokenLabel: '令牌',
    newPasswordLabel: '新密码',
    confirmPasswordLabel: '确认新密码',
    submitButton: '提交',
    backToLogin: '返回登录',
    successMsg: '密码已更新',
    emailRequired: '请输入邮箱',
    emailFormatError: '邮箱格式不正确',
    tokenRequired: '请输入令牌',
    passwordRequired: '请输入新密码',
    passwordMinLength: '密码至少 8 位',
    passwordMustContainLetterAndNumber: '需包含字母与数字',
    confirmPasswordMismatch: '两次输入不一致',
    operationFailed: '操作失败',
  },

  // OAuth新账号页面
  oauthNewAccount: {
    title: '完善账号信息',
    fullNameLabel: '姓名',
    saveButton: '保存',
    continueButton: '继续',
    loginFailed: '登录失败',
    loggedIn: '已登录',
    loggedInVia: '已通过 {provider} 登录',
    profileUpdated: '资料已更新',
    saveFailed: '保存失败',
    bindOtherAccounts: '绑定其他第三方账号',
    bindGithub: '绑定 GitHub',
    bindMicrosoft: '绑定 Microsoft',
    bindQQ: '绑定 QQ',
  },

  // 使用文档页面
  docsUsage: {
    title: '使用文档',
    subtitle: '平台使用说明与上手指南',
    backToHome: '返回首页',
  },

  // 网页嵌入页面
  webEmbed: {
    loading: '加载中...',
  },

  // 登录回调页面
  loginCallback: {
    loggingIn: '正在登录',
    loginFailed: '登录失败',
  },
}
